import {
  Identifiable,
  Resource,
  ProjectResource,
  RetrieveResourceProjectsQuery,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getResourceProjects(httpClient: HttpClient) {
  return (
    resource: Identifiable<Resource>,
    query: RetrieveResourceProjectsQuery,
  ) =>
    httpClient
      .sendHttpRequest<{
        _embedded: { projectMembers: Identifiable<ProjectResource>[] };
      }>({
        endpoint: `/projectMembers/search/rsql?query=member.uuid==${resource.uuid} and project.zone.savingTemplates!=true&projection=details&page=${query.start}&size=${query.limit}`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) =>
        _embedded && _embedded.projectMembers ? _embedded.projectMembers : [],
      )
      .then((projectMembers) => projectMembers.map(({ project }) => project));
}

export { getResourceProjects };
